/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Caricamento in corso...',
	'dlg_close': 'Chiudi',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annulla',
	'dlg_back': 'Torna indietro',

	// Slider
	'sliderRegionLabel': 'Controllo dispositivo di scorrimento, utilizzare le frecce destra e sinistra per spostare le barre del dispositivo di scorrimento.',
	'sliderHandleLabel': 'Barra del dispositivo di scorrimento',
	'a11ySliderHandleLabel': 'Barra del dispositivo di scorrimento %{sliderValue}',
	'sliderInputLabel': 'valore',

	// Side bar
	'sidebarAdd': 'Aggiungi',
	'clearTextFilterValue': 'Annulla',
	'missingDataSetData': 'I dati per questo dataset non sono disponibili. Aggiornare il dataset o rivolgersi all\'amministratore per accedere all\'origine.',

	// Toolbar
	'toolbarRegionLabel': 'Barra degli strumenti',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Famiglia di caratteri',
	'fontSizeSelect': 'Dimensione carattere',
	'bold': 'Grassetto',
	'italic': 'Corsivo',
	'underline': 'Sottolineato',
	'justifyLeft': 'Allinea a sinistra',
	'justifyCenter': 'Allinea al centro',
	'justifyRight': 'Allinea a destra',
	'insertOrderedList': 'Elenco ordinato',
	'insertUnorderedList': 'Elenco non ordinato',
	'fontColorPicker': 'Selettore colori',
	'textWrap': 'Testo a capo',
	'restore': 'Ripristina impostazioni predefinite',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Numero di risultati',
	'topbottomPercentLabel': 'Percentuale',
	'topbottomNumberOfResultsLimit': 'Il valore può essere %{lower} - %{higher}',
	'topbottomSelectOption': 'Opzione primi elementi o ultimi elementi',
	'topbottomOptionLabel': 'Mostra',
	'searchByLabel': 'Per',
	'searchNoMatches': 'Nessuna corrispondenza trovata',
	'topbottomRankColumnLabel': 'Aggiungi una colonna di classifica alla tabella',
	'topbottomNone': 'Nessuna',
	'topCount': 'Numero massimo',
	'topPercent': '% massima',
	'bottomCount': 'Numero minimo',
	'bottomPercent': '% minima',
	'searchColumn': 'Individuare una colonna',
	'searchColumnAriaLabel': 'Individuare una colonna. Immettere il nome della colonna in base alla quale effettuare la ricerca, quindi utilizzare la freccia in basso per trovare la colonna in un elenco',
	'rankColumnLabel': 'Classifica (%{columnLabel})',
	'topbottomClearLabel': 'Annulla',

	// Format
	'formatAuto': 'Automatico',
	'formatConvertPercent': 'Converti decimali in percentuale',
	'formatAbbreviate': 'Abbrevia',
	'formatUseGrouping': 'Utilizza separatore delle migliaia',
	'dateStyle': 'Stile data',
	'dateTimeStyle': 'Stile Data/Ora',
	'formatMissingValueCharactersInfo': 'I caratteri per i valori mancanti specificano i caratteri da visualizzare quando il valore non è presente.',
	'currencySymbolLabel': 'Simbolo valuta',
	'customSymbolPlaceholder': 'Aggiungi un simbolo',
	'customSymbolLabelInfo': 'Specifica uno o più caratteri da utilizzare come simbolo personalizzato. Questo simbolo precede il numero e l\'eventuale segno. ',
	'numberLabel': 'Etichetta numero',
	'numberPositionLabel': 'Posizione etichetta',
	'numberLabelInfo': 'Specifica un\'etichetta del numero formattato posizionato come prefisso o suffisso a seconda della posizione dell\'etichetta. ',
	'nullValueDefault': '<valore predefinito>',
	'nullValueContent': '(nessun valore)',
	'default': 'Impostazione predefinita',
	'beginning': 'Inizio',
	'end': 'Fine',

	// More data indicator
	'moreDataIndicator': 'I dati sono stati ridotti a %{threshold} elementi. Applicare un filtro per mostrarne di meno.',

	// Expanded View / Focus mode
	'evCollapse': 'Comprimi',
	'duplicate': 'Duplica',
	'copyOf': 'Copia di %{name}',
	'unableToDuplicateBoard': 'Impossibile duplicare "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Impossibile caricare gli oggetti.',

	// Custom widgets
	'customWidget': 'Widget personalizzato'
});
